import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { N1TransactionsEdit } from "./edit";
import { N1TransactionsNew } from "./new";
import { N1TransactionsTable } from "./table";

export default function N1Transactions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Transactions");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<N1TransactionsEdit />} />
      <Route index element={<N1TransactionsTable />} />
      <Route path="/new" element={<N1TransactionsNew />} />
    </Routes>
  );
}
